import React from "react";
import box_img1 from "../../../assets/box_img-01.png";
import box_img2 from "../../../assets/box_img-02.png";
import box_img3 from "../../../assets/box_img-03.png";
import box_img4 from "../../../assets/box_img-04.png";
import box_img5 from "../../../assets/box_img-05.png";
import { Link } from "react-router-dom";
const InnerContent: React.FC = () => {
  const bannerNameBirds = "Birds";
  const bannerNameCrocodile = "Crocodile";
  const bannerNameDragon = "DragonFish";
  return (
    <>
      <div className="inner-content eservies-bg">
        <div className="container">
          <div className="row mt-3">
            <div className="col-lg-4 mb-4">
              <div className="eservices-bx active">
                <figure>
                  <img src={box_img3} alt="" className="img-fluid" />
                </figure>
                <div className="eservice-content">
                  <h2>Make a payment / View Invoices</h2>

                  <ul>
                    <li>
                      <Link to="/payments">Make an Online Payment</Link>
                    </li>
                    {/*<li>
                      <Link to="/tradenet-payments">Make an Online Tradenet Payment</Link>
                    </li>*/}
                    <li>
                      <Link to="/payment-dashboard">View Payment Receipt</Link>
                    </li>
                    <li>
                      <Link to="/invoice-dashboard">View Invoices</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="eservices-bx">
                <figure>
                  <img src={box_img2} alt="" className="img-fluid" />
                </figure>
                <div className="eservice-content">
                  <h2>Register for Inspection</h2>
                  <ul>
                    <li>
                      Inspection Updates
                      <ul>
                        <li>
                          <Link
                            to="/isr-inspections"
                            state={bannerNameCrocodile}
                          >
                            Submit Inspection Updates
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      Import/Export Inspections
                      <ul>
                        <li>
                          <Link
                            to="/vethealth-inspections"
                            state={bannerNameCrocodile}
                          >
                            Schedule Import/Export/Transhipment Inspection
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="eservices-bx ">
                <figure>
                  <img src={box_img4} alt="" className="img-fluid" />
                </figure>
                <div className="eservice-content">
                  <h2>Microchip Registration</h2>

                  <ul>
                    <li>
                      <Link
                        to="/application-registration"
                        state={bannerNameBirds}
                      >
                        CITES Birds Registration
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/application-registration"
                        state={bannerNameCrocodile}
                      >
                        CITES Crocodile Skins Registration
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/application-registration"
                        state={bannerNameDragon}
                      >
                        CITES Dragonfish (arowana) Registration
                      </Link>
                    </li>
                    <li>
                      <Link to="/application-for-pets">
                        Microchip Registration for Pets
                      </Link>
                    </li>
                    <li>
                      <Link to="/application-for-pets" state={{ bannerId: 10 }}>
                        Transfer of Pets Ownership
                      </Link>
                    </li>
                    <li>
                      <Link to="/application-for-pets" state={{ bannerId: 5 }}>
                        Microchip Enquiry
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="eservices-bx">
                <figure>
                  <img src={box_img1} alt="" className="img-fluid" />
                </figure>
                <div className="eservice-content">
                  <h2>Local Dragon Fish Registration</h2>

                  <ul>
                    <li>
                      Schedule an Inspection Appointment
                      <ul>
                        <li>
                          <Link
                            to="/app-inspection"
                            state={bannerNameCrocodile}
                          >
                            Dragon Fish (Arowana) Harvest Inspection
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>

                  <ul>
                    <li>
                      Harvest Details Registration
                      <ul>
                        <li>
                          <Link
                            to="/harvest-details"
                            state={bannerNameCrocodile}
                          >
                            Dragon Fish Harvest Registration
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      Microchip registration
                      <ul>
                        <li>
                          <Link
                            to="/harvest-microchipregistration"
                            state={{ from: "/application-registration" }}
                          >
                            Microchip registration
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="eservices-bx active">
                <figure>
                  <img src={box_img5} alt="" className="img-fluid" />
                </figure>
                <div className="eservice-content">
                  <h2>Submit Laboratory Test Application</h2>
                  <ul>
                    <li>
                      <Link to="/choose-application">
                        Submit Laboratory Application
                      </Link>
                    </li>
                    <li>
                      <Link to="/lab-dashboard">
                        Laboratory Application Status Enquiry
                      </Link>
                    </li>
                    <li>
                      <Link to="/savedraft-dashboard">
                        Resume Draft Laboratory Application
                      </Link>
                    </li>
                    <li>
                      <Link to="/copylab-dashboard">
                        Copy Laboratory Application
                      </Link>
                    </li>
                    <li>
                      <Link to="/labresults-dashboard">
                        Submit Laboratory Results
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="eservices-bx active">
                <figure>
                  <img src={box_img5} alt="" className="img-fluid" />
                </figure>
                <div className="eservice-content">
                  <h2>Other Services</h2>
                  <ul>
                    <li>
                      <Link to="/acs-scheme">
                        Assurance Certification Scheme (ACS)
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/lab-dashboard">
                        Laboratory Application Status Enquiry
                      </Link>
                    </li>
                    <li>
                      <Link to="/savedraft-dashboard">
                        Resume Draft Laboratory Application
                      </Link>
                    </li>
                    <li>
                      <Link to="/copylab-dashboard">
                        Copy Laboratory Application
                      </Link>
                    </li>
                    <li>
                      <Link to="/labresults-dashboard">
                        Submit Laboratory Results
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>

            {/* FORM SG SECTION */}
            {/*{UAT_AUTH_SCREEN === "NO" && (<div className="col-lg-4 mb-4">
              <div className="eservices-bx active">
                <figure>
                  <img src={box_img5} alt="" className="img-fluid" />
                </figure>
                <div className="eservice-content">
                  <h2>APPLICATION FOR LABORATORY SERVICES</h2>
                  <ul>
                    <li>
                      <a
                        href="https://go.gov.sg/npb-cavs-labsubmission"
                        target="_blank"
                      >
                        Application for CAVS Laboratory Services
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://go.gov.sg/npb-psh-labsubmission"
                        target="_blank"
                      >
                        Application for Plant Health Laboratory Services
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>)}*/}

          </div>
        </div>
      </div>
    </>
  );
};

export default InnerContent;
